import type { CourseEntityChangeStatus } from "@repo/app-types/entities/course";

export function getChangeStatusHighlightClasses(
  changeStatus: CourseEntityChangeStatus,
) {
  switch (changeStatus) {
    case "new":
      return "border-l-2 border-l-emerald-500 bg-emerald-50/50";
    case "edited":
      return "border-l-2 border-l-amber-500 bg-amber-50/50";
    default:
      return "";
  }
}
